module.exports = __webpack_public_path__ + "assets/img/be8c3712f98a786db6ade2f6d2ef25af.svg";